export default __webpack_public_path__ + "static/media/brakekit-turquoise.40428928.webp";